import { Controller } from "stimulus";

// Redirects to a target URL based on one media query (evaluated on connect and on change). The EM
// calendar page is the only view that wires it: below=true with the (min-width) query and the list URL,
// so a viewport that does NOT match (mobile, below the breakpoint) is redirected to the list. The list
// page attaches no redirect — list is the default at every width, so there is no desktop→calendar bounce.
export default class extends Controller {
  static values = { query: String, url: String, below: Boolean }

  queryValue: string
  urlValue: string
  belowValue: boolean
  mediaQuery: MediaQueryList
  onChange: () => void

  connect() {
    this.mediaQuery = window.matchMedia(this.queryValue)
    this.onChange = () => this.redirectIfMatching()
    this.mediaQuery.addEventListener("change", this.onChange)
    this.redirectIfMatching()
  }

  disconnect() {
    this.mediaQuery.removeEventListener("change", this.onChange)
  }

  redirectIfMatching() {
    const onWrongSide = this.belowValue ? !this.mediaQuery.matches : this.mediaQuery.matches

    if (onWrongSide) window.location.assign(this.urlValue)
  }
}
